import generateJavaRequest from './services/jrequest';

const jrequest = generateJavaRequest('payment');

/**
 * 获取支付链接
 * @param {*} condiotions
 */
export function comfirmPay(condiotions) {
  return jrequest('pay', condiotions, { method: 'post' });
}

